import * as React from 'react'
import { tv, VariantProps } from 'tailwind-variants'
// import cameraIcon from '@cannect/assets/svg/icon_camera.svg'

const cameraButtonVariants = tv({
  base: 'flex cursor-pointer items-center justify-center gap-2 rounded-lg border-none bg-white px-4 py-2 text-primary transition-colors duration-200 hover:border-gray-400 hover:bg-gray-50',
  variants: {
    size: {
      sm: 'px-3 py-1.5 text-sm',
      default: 'px-4 py-2 text-base',
      lg: 'px-6 py-3 text-lg'
    },
    disabled: {
      true: 'cursor-not-allowed opacity-50 hover:border-gray-300 hover:bg-white',
      false: ''
    }
  },
  defaultVariants: {
    size: 'default',
    disabled: false
  }
})

const iconVariants = tv({
  base: 'text-primary',
  variants: {
    size: {
      sm: 'h-4 w-4',
      default: 'h-5 w-5',
      lg: 'h-6 w-6'
    }
  },
  defaultVariants: {
    size: 'default'
  }
})

export interface CameraButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof cameraButtonVariants> {
  onTakePhoto?: () => void
  children?: React.ReactNode
}

const CameraButton = React.forwardRef<HTMLButtonElement, CameraButtonProps>(
  ({ className, size = 'default', disabled = false, onTakePhoto, children, ...props }, ref) => {

    const handleClick = () => {
      if (!disabled && onTakePhoto) {
        onTakePhoto()
      }
    }

    return (
      <button
      ref={ref}
      type="button"
      className={cameraButtonVariants({ size, disabled, className })}
      onClick={handleClick}
      disabled={disabled}
      {...props}>
      <svg 
        width="28" 
        height="28" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className={iconVariants({ size })}>
        <path 
          d="M3 9C3 7.89543 3.89543 7 5 7H6.5C7.12951 7 7.72229 6.70361 8.1 6.2L9.15 4.8C9.52771 4.29639 10.1205 4 10.75 4H13.25C13.8795 4 14.4723 4.29639 14.85 4.8L15.9 6.2C16.2777 6.70361 16.8705 7 17.5 7H19C20.1046 7 21 7.89543 21 9V18C21 19.1046 20.1046 20 19 20H5C3.89543 20 3 19.1046 3 18V9Z" 
          stroke="#6B7B3C" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"/>
        <circle 
          cx="12" 
          cy="13" 
          r="4" 
          stroke="#6B7B3C" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"/>
      </svg>
      <span style={{ color: '#6B7B3C', fontWeight: '500' }}>{children || 'Tirar Foto'}</span>
    </button>
    )
  }
)

CameraButton.displayName = 'CameraButton'

export { CameraButton, cameraButtonVariants }
